import { render, staticRenderFns } from "./HomeSectorPrimers.vue?vue&type=template&id=6ceef5ee&scoped=true&"
import script from "./HomeSectorPrimers.vue?vue&type=script&lang=js&"
export * from "./HomeSectorPrimers.vue?vue&type=script&lang=js&"
import style0 from "./HomeSectorPrimers.vue?vue&type=style&index=0&id=6ceef5ee&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceef5ee",
  null
  
)

export default component.exports